import { Button, ButtonStyle } from '@atlas/components';
import classNames from 'classnames';
import { type FC, useCallback } from 'react';
import useIntl from 'utils/useIntl';

import styles from './PaymentForm.module.scss';

type DepositItemProps = {
  item: number;
  isSelected?: boolean;
  onSelect: (item: number) => void;
};

const DepositItem: FC<DepositItemProps> = ({ item, onSelect, isSelected }) => {
  const { formatDynamicFractionMoney } = useIntl();

  const handleClick = useCallback(() => {
    onSelect(item);
  }, [item, onSelect]);

  return (
    <Button
      className={classNames(styles['payment-templates-item'], {
        [styles.active]: isSelected,
      })}
      style={ButtonStyle.outline}
      key={item}
      onClick={handleClick}
    >
      {formatDynamicFractionMoney(item)}
    </Button>
  );
};

export default DepositItem;
